import React from 'react';

import { getFormattedDateAndUtcParts } from 'utils/dateTime';
import { gray } from 'utils/color-styles';

export const DateRangeWithTimeZone = ({
  startingAt,
  timeZone,
  endingAt,
  withTime,
  fontSize,
}: {
  startingAt?: string;
  timeZone?: string;
  endingAt?: string;
  withTime?: boolean;
  fontSize?: number;
}) => {
  if (!startingAt) {
    return null;
  }
  const { datePart, utcPart } = getFormattedDateAndUtcParts({
    startingAt,
    timeZone,
    endingAt,
    withTime,
  });

  return (
    <div style={{ fontSize: fontSize || 12, fontWeight: 300 }}>
      <span>{datePart}</span>
      {utcPart && (
        <span
          style={{
            color: gray,
            fontStyle: 'italic',
          }}
        >
          {' '}
          {utcPart}
        </span>
      )}
    </div>
  );
};
